import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Service from "./Pages/Service";
import GalleryOuter from "./Pages/GalleryOuter";
import GalleryPage from "./Pages/GalleryPage";
import TermsCondition from "./Pages/TermsCondition";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import FaqPage from "./Pages/FaqPage";
import BlogPage from "./Pages/BlogPage";
import BlogInPage from "./Pages/BlogInPage";
import ContactPage from "./Pages/ContactPage";
import ErrorPage from "./Pages/ErrorPage";
import LegacyPage from "./Pages/LegacyPage";

// Admin pages
import AdminLayout from "./Pages/AdminLayout";
import BlogsList from "./Component/admin/BlogsList";
import AddBlog from "./Component/admin/AddBlog";
import AddBanner from "./Component/admin/AddBanner";
import BannerList from "./Component/admin/BannerList";
import AddWork from "./Component/admin/AddWork";
import WorkList from "./Component/admin/WorkList";
import GalleryList from "./Component/admin/GalleryList";
import AddGallery from "./Component/admin/AddGallery";
import EventList from "./Component/admin/EventList";
import AddEvent from "./Component/admin/AddEvent";
import AddTestimonial from "./Component/admin/AddTestimonial";
import TestimonialList from "./Component/admin/TestimonialList";
import AdminLogin from "./Component/admin/AdminLogin";

// Loader
import Loader from "./Component/UserEnd/ScreenLoader";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Assets/Css/style.css";
import "./Assets/Css/admin_style.css";

const StylesLoader = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) {
      document.body.classList.add("admin-page");
    } else {
      document.body.classList.remove("admin-page");
    }
  }, [location]);
  return null;
};

// 🔒 Protect admin routes
const RequireAdminAuth = () => {
  const token = sessionStorage.getItem("admin_token");
  return token ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

// 🚫 Redirect logged-in admin away from login page
const RedirectIfAuthenticated = () => {
  const token = sessionStorage.getItem("admin_token");
  return token ? <Navigate to="/admin/bannerList" replace /> : <Outlet />;
};

// Public Route Wrapper with Loader
const PublicRoute = ({ children }) => {
  return <Loader>{children}</Loader>;
};

function App() {
  return (
    <Router>
      <StylesLoader />
      <Routes>
        {/* Public routes WITH loader */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          }
        />
        <Route
          path="/about"
          element={
            <PublicRoute>
              <About />
            </PublicRoute>
          }
        />
        <Route
          path="/service"
          element={
            <PublicRoute>
              <Service />
            </PublicRoute>
          }
        />
        <Route
          path="/gallery"
          element={
            <PublicRoute>
              <GalleryOuter />
            </PublicRoute>
          }
        />
        <Route
          path="/gallery-page/:eventId"
          element={
            <PublicRoute>
              <GalleryPage />
            </PublicRoute>
          }
        />
        <Route
          path="/terms-condition"
          element={
            <PublicRoute>
              <TermsCondition />
            </PublicRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <PublicRoute>
              <PrivacyPolicy />
            </PublicRoute>
          }
        />
        <Route
          path="/faq"
          element={
            <PublicRoute>
              <FaqPage />
            </PublicRoute>
          }
        />
        <Route
          path="/blog-page"
          element={
            <PublicRoute>
              <BlogPage />
            </PublicRoute>
          }
        />
        <Route
          path="/blog/:id"
          element={
            <PublicRoute>
              <BlogInPage />
            </PublicRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <PublicRoute>
              <ContactPage />
            </PublicRoute>
          }
        />
        <Route
          path="/legacy"
          element={
            <PublicRoute>
              <LegacyPage />
            </PublicRoute>
          }
        />
        <Route
          path="*"
          element={
            <PublicRoute>
              <ErrorPage />
            </PublicRoute>
          }
        />

        {/* Admin Login - WITHOUT loader */}
        {/* 🚫 Redirect if already logged in */}
        <Route element={<RedirectIfAuthenticated />}>
          <Route path="/admin/login" element={<AdminLogin />} />
        </Route>

        {/* Protected Admin Routes - WITHOUT loader */}
        <Route path="/admin" element={<RequireAdminAuth />}>
          <Route element={<AdminLayout />}>
            <Route path="blogList" element={<BlogsList />} />
            <Route path="addBlog" element={<AddBlog />} />
            <Route path="addBlog/:id" element={<AddBlog />} />
            <Route path="addBanner" element={<AddBanner />} />
            <Route path="addBanner/:id" element={<AddBanner />} />
            <Route path="bannerList" element={<BannerList />} />
            <Route path="addWork" element={<AddWork />} />
            <Route path="addWork/:id" element={<AddWork />} />
            <Route path="workList" element={<WorkList />} />
            <Route path="galleryList" element={<GalleryList />} />
            <Route path="addGallery" element={<AddGallery />} />
            <Route path="addGallery/:id" element={<AddGallery />} />
            <Route path="eventList" element={<EventList />} />
            <Route path="addEvent" element={<AddEvent />} />
            <Route path="addEvent/:id" element={<AddEvent />} />
            <Route path="addTestimonial" element={<AddTestimonial />} />
            <Route path="addTestimonial/:id" element={<AddTestimonial />} />
            <Route path="testimonialList" element={<TestimonialList />} />
          </Route>
        </Route>

        <Route
          path="*"
          element={
            <PublicRoute>
              <ErrorPage />
            </PublicRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
